var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBookshelf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -83 512.00003 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb211"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 23.2090703648,
    x2: 123.0219069786,
    xlinkHref: "#a",
    y1: 161.0574086326,
    y2: 161.0574086326
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 512 387.46009)",
    gradientUnits: "userSpaceOnUse",
    x1: 412.9294,
    x2: 461.4109,
    xlinkHref: "#a",
    y1: 158.7349,
    y2: 158.7349
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2e9dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2282,
    stopColor: "#f0e4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5158,
    stopColor: "#ead7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8338,
    stopColor: "#e0c2ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dab49d"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 40.762244966,
    x2: 105.4688327696,
    xlinkHref: "#d",
    y1: 47.8855827492,
    y2: 47.8855827492
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 40.762244966,
    x2: 105.4688327696,
    xlinkHref: "#d",
    y1: 76.6521645216,
    y2: 76.6521645216
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 40.762244966,
    x2: 105.4688327696,
    xlinkHref: "#d",
    y1: 105.418746294,
    y2: 105.418746294
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 40.762244966,
    x2: 105.4688327696,
    xlinkHref: "#d",
    y1: 134.1853280664,
    y2: 134.1853280664
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(.9727 -.248571 .248571 .9727 -51.449173 19.81096)",
    gradientUnits: "userSpaceOnUse",
    x1: 357.0555,
    x2: 456.4784,
    y1: 247.5221,
    y2: 247.5221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ccbf7"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(.9727 -.248571 .248571 .9727 -51.449173 19.81096)",
    gradientUnits: "userSpaceOnUse",
    x1: 357.0531,
    x2: 456.4808,
    xlinkHref: "#j",
    y1: 158.1092,
    y2: 158.1092
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(.9727 -.248571 .248571 .9727 -51.449173 19.81096)",
    gradientUnits: "userSpaceOnUse",
    x1: 357.0531,
    x2: 456.4808,
    xlinkHref: "#j",
    y1: 134.7924,
    y2: 134.7924
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#575c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45425a"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientTransform: "matrix(.9727 -.248571 .248571 .9727 -51.449173 19.81096)",
    gradientUnits: "userSpaceOnUse",
    x1: 419.042,
    x2: 394.4919,
    xlinkHref: "#m",
    y1: 243.979,
    y2: 243.979
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientTransform: "matrix(.9727 -.248571 .248571 .9727 -51.449173 19.81096)",
    gradientUnits: "userSpaceOnUse",
    x1: 419.042,
    x2: 394.4919,
    xlinkHref: "#m",
    y1: 305.0857,
    y2: 305.0857
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6e56f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1452,
    stopColor: "#c1e46e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3131,
    stopColor: "#b3e16d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4923,
    stopColor: "#9cdd6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6794,
    stopColor: "#7cd767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8707,
    stopColor: "#52cf62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32c95f"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 123.0219069786,
    x2: 222.8347435924,
    xlinkHref: "#p",
    y1: 180.7380947362,
    y2: 180.7380947362
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 217.4571350072,
    x2: 38.4630628016,
    y1: 213.6999661544,
    y2: 164.0992922926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32c95f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    stopColor: "#2dc05b",
    stopOpacity: 0.105882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007a3e"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 172.9282750894,
    x2: 172.9282750894,
    xlinkHref: "#p",
    y1: 281.5163027452,
    y2: 333.4859313504
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientTransform: "matrix(1.003922 0 0 -1.003922 0 740.69672)",
    gradientUnits: "userSpaceOnUse",
    x1: 172.2527,
    x2: 172.2527,
    xlinkHref: "#p",
    y1: 658.1558,
    y2: 709.9224
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4c54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3f45"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 185.2515180316,
    x2: 160.6051325394,
    xlinkHref: "#u",
    y1: 121.1410683438,
    y2: 121.1410683438
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 185.2515180316,
    x2: 160.6051325394,
    xlinkHref: "#u",
    y1: 194.4698402444,
    y2: 194.4698402444
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 185.2515180316,
    x2: 160.6051325394,
    xlinkHref: "#u",
    y1: 255.8162007218,
    y2: 255.8162007218
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 187.9581921358,
    x2: 127.8826965182,
    y1: 156.102752386,
    y2: 92.7924193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972e07",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#582707"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d767c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    stopColor: "#d363c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#c656bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b342ac"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 222.8371530052,
    x2: 322.649989619,
    xlinkHref: "#z",
    y1: 161.0574086326,
    y2: 161.0574086326
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 512 387.46009)",
    gradientUnits: "userSpaceOnUse",
    x1: 214.0812,
    x2: 262.5627,
    xlinkHref: "#z",
    y1: 241.7811,
    y2: 241.7811
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 222.8347435924,
    x2: 322.6523990318,
    xlinkHref: "#a",
    y1: 274.2293349082,
    y2: 274.2293349082
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 222.8347435924,
    x2: 322.6523990318,
    xlinkHref: "#a",
    y1: 240.3466662316,
    y2: 240.3466662316
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 222.8347435924,
    x2: 322.6523990318,
    xlinkHref: "#a",
    y1: 47.8855827492,
    y2: 47.8855827492
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 265.6390662986,
    x2: 155.962796427,
    y1: 210.2315160366,
    y2: 147.9994955708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b342ac",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2597,
    stopColor: "#a4319c",
    stopOpacity: 0.258824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7199,
    stopColor: "#8d1885",
    stopOpacity: 0.721569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#850f7c"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    y1: 291.0525578232,
    y2: 317.7470445876
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4396,
    stopColor: "#feb0bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#f9a9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7108,
    stopColor: "#f19eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8021,
    stopColor: "#e68db7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8803,
    stopColor: "#d777b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9483,
    stopColor: "#c55cb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b342ac"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    y1: 317.742225762,
    y2: 348.2772161374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2465,
    stopColor: "#ffdf41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#ffce2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#ffb211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb211"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m107.488281 316.722656c-23.058593 2.941406-45.6875 2.941406-68.746093 0-8.890626-1.136718-15.535157-8.738281-15.535157-17.699218 0-91.976563 0-183.953126 0-275.929688 0-8.960938 6.644531-16.566406 15.535157-17.699219 23.058593-2.945312 45.6875-2.945312 68.746093-.003906 8.890625 1.136719 15.535157 8.742187 15.535157 17.699219v275.933594c0 8.960937-6.644532 16.5625-15.535157 17.699218zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.351562 152.195312c11.246094-1.433593 22.28125-1.433593 33.527344 0 4.332032.554688 7.570313 4.261719 7.570313 8.628907v134.554687c0 4.367188-3.238281 8.078125-7.570313 8.628906-11.246094 1.433594-22.28125 1.4375-33.527344 0-4.332031-.550781-7.570312-4.261718-7.570312-8.628906 0-44.851562 0-89.703125 0-134.554687 0-4.367188 3.238281-8.074219 7.570312-8.628907zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40.761719 41.257812h64.707031v13.253907h-64.707031zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m40.761719 70.027344h64.707031v13.25h-64.707031zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m40.761719 98.792969h64.707031v13.253906h-64.707031zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m40.761719 127.558594h64.707031v13.253906h-64.707031zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m477.566406 301.773438c-21.617187 8.558593-43.539062 14.164062-66.609375 17.019531-8.894531 1.101562-17.210937-4.621094-19.429687-13.300781-22.773438-89.113282-45.542969-178.226563-68.316406-267.339844-2.21875-8.683594 2.335937-17.695313 10.667968-20.996094 21.609375-8.558594 43.535156-14.164062 66.609375-17.019531 8.890625-1.101563 17.210938 4.621093 19.429688 13.300781 22.769531 89.113281 45.542969 178.226562 68.3125 267.34375 2.21875 8.679688-2.332031 17.691406-10.664063 20.992188zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m430.210938 53.71875 3.28125 12.839844-96.707032 24.714844-3.285156-12.84375zm0 0",
    fill: "url(#k)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m424.417969 31.039062 3.28125 12.839844-96.710938 24.714844-3.28125-12.84375zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m413.847656 179.375-5.707031 1.457031c-5.015625 1.28125-10.125-1.746093-11.40625-6.761719l-7.664063-30c-1.285156-5.015624 1.746094-10.125 6.761719-11.40625l5.707031-1.457031c5.019532-1.285156 10.125 1.746094 11.40625 6.761719l7.667969 30c1.28125 5.015625-1.746093 10.121094-6.765625 11.40625zm0 0",
    fill: "url(#n)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m429.039062 238.808594-5.710937 1.460937c-5.015625 1.28125-10.121094-1.746093-11.40625-6.765625l-7.664063-29.996094c-1.28125-5.019531 1.746094-10.125 6.761719-11.40625l5.710938-1.460937c5.015625-1.28125 10.121093 1.746094 11.40625 6.765625l7.664062 29.996094c1.28125 5.019531-1.746093 10.125-6.761719 11.40625zm0 0",
    fill: "url(#o)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m207.304688 316.722656c-23.0625 2.941406-45.691407 2.941406-68.75 0-8.890626-1.136718-15.53125-8.738281-15.53125-17.699218 0-91.976563 0-144.59375 0-236.570313 0-8.960937 6.640624-16.566406 15.53125-17.699219 23.058593-2.941406 45.6875-2.941406 68.75 0 8.886718 1.132813 15.53125 8.738282 15.53125 17.699219v236.570313c0 8.960937-6.644532 16.5625-15.53125 17.699218zm0 0",
    fill: "url(#q)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m123.023438 299.023438c0 8.960937 6.640624 16.5625 15.53125 17.699218 23.058593 2.941406 45.6875 2.941406 68.75 0 8.886718-1.136718 15.53125-8.738281 15.53125-17.699218 0-53.800782 0-94.136719 0-136.757813l-99.8125-99.8125zm0 0",
    fill: "url(#r)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m138.554688 316.722656c23.058593 2.941406 45.6875 2.941406 68.75 0 6.976562-.890625 12.554687-5.773437 14.636718-12.167968-2.082031-6.390626-7.660156-11.273438-14.636718-12.164063-23.0625-2.945313-45.691407-2.941406-68.75 0-6.980469.890625-12.554688 5.777344-14.640626 12.167969 2.085938 6.390625 7.660157 11.273437 14.640626 12.164062zm0 0",
    fill: "url(#s)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m138.554688 44.753906c23.058593-2.941406 45.6875-2.941406 68.75 0 6.976562.890625 12.554687 5.773438 14.636718 12.167969-2.082031 6.390625-7.660156 11.273437-14.636718 12.164063-23.0625 2.945312-45.691407 2.941406-68.75 0-6.980469-.890626-12.554688-5.777344-14.640626-12.167969 2.085938-6.390625 7.660157-11.273438 14.640626-12.164063zm0 0",
    fill: "url(#t)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m175.875 161.480469h-5.894531c-5.175781 0-9.375-4.199219-9.375-9.378907v-61.921874c0-5.179688 4.199219-9.378907 9.375-9.378907h5.894531c5.179688 0 9.375 4.199219 9.375 9.378907v61.921874c0 5.179688-4.195312 9.378907-9.375 9.378907zm0 0",
    fill: "url(#v)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m175.875 219.328125h-5.894531c-5.175781 0-9.375-4.199219-9.375-9.378906v-30.960938c0-5.179687 4.199219-9.375 9.375-9.375h5.894531c5.179688 0 9.375 4.195313 9.375 9.375v30.960938c0 5.179687-4.195312 9.378906-9.375 9.378906zm0 0",
    fill: "url(#w)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m175.875 280.675781h-5.894531c-5.175781 0-9.375-4.199219-9.375-9.378906v-30.960937c0-5.179688 4.199219-9.378907 9.375-9.378907h5.894531c5.179688 0 9.375 4.199219 9.375 9.378907v30.960937c0 5.179687-4.195312 9.378906-9.375 9.378906zm0 0",
    fill: "url(#x)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m160.605469 100.035156v52.066406c0 5.179688 4.199219 9.378907 9.378906 9.378907h5.890625c5.179688 0 9.378906-4.199219 9.378906-9.378907v-27.417968zm0 0",
    fill: "url(#y)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m307.117188 316.722656c-23.0625 2.941406-45.691407 2.941406-68.75 0-8.886719-1.136718-15.53125-8.738281-15.53125-17.699218 0-91.976563 0-183.953126 0-275.929688 0-8.960938 6.644531-16.566406 15.53125-17.699219 23.058593-2.945312 45.6875-2.945312 68.75-.003906 8.890624 1.136719 15.53125 8.742187 15.53125 17.699219v275.933594c0 8.960937-6.640626 16.5625-15.53125 17.699218zm0 0",
    fill: "url(#A)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m255.980469 68.824219c11.246093-1.433594 22.28125-1.4375 33.523437 0 4.335938.550781 7.574219 4.261719 7.574219 8.628906v134.554687c0 4.367188-3.238281 8.074219-7.574219 8.628907-11.242187 1.433593-22.277344 1.4375-33.523437 0-4.332031-.554688-7.574219-4.261719-7.574219-8.628907 0-44.851562 0-89.703124 0-134.554687 0-4.367187 3.242188-8.078125 7.574219-8.628906zm0 0",
    fill: "url(#B)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m222.835938 267.601562h99.816406v13.253907h-99.816406zm0 0",
    fill: "url(#C)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m222.835938 233.71875h99.816406v13.253906h-99.816406zm0 0",
    fill: "url(#D)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m222.835938 41.257812h99.816406v13.253907h-99.816406zm0 0",
    fill: "url(#E)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m222.835938 299.023438c0 8.960937 6.644531 16.5625 15.53125 17.699218 23.0625 2.941406 45.691406 2.941406 68.75 0 8.890624-1.132812 15.53125-8.738281 15.53125-17.699218 0-45.585938 0-91.167969 0-136.753907l-99.8125-99.8125zm0 0",
    fill: "url(#F)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m451.929688 332.824219h-391.859376c-8.558593 0-15.5-6.9375-15.5-15.5 0-8.558594 6.941407-15.5 15.5-15.5h391.859376c8.558593 0 15.5 6.941406 15.5 15.5 0 8.5625-6.941407 15.5-15.5 15.5zm0 0",
    fill: "url(#G)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m496.5 345.910156h-481c-8.558594 0-15.5-6.9375-15.5-15.5 0-8.558594 6.941406-15.5 15.5-15.5h481c8.558594 0 15.5 6.941406 15.5 15.5 0 8.5625-6.941406 15.5-15.5 15.5zm0 0",
    fill: "url(#H)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookshelf);
export default __webpack_public_path__ + "static/media/icon-bookshelf.0124efac1c3f7db44d5a579d65edf7de.svg";
export { ForwardRef as ReactComponent };